export default {"src":"/_next/static/media/discount.903f28c8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};